import { useRouter } from "next/router";
import { useCallback } from "react";
export var useAffiliate = function() {
    var router = useRouter();
    /**
   * Check for TradeDoubler affiliate params in url
   * see https://dev.tradedoubler.com/tracking/advertiser/#Pixel_Redirect
   */ var redirectToTradedoubler = useCallback(function(bookingUrl) {
        var url = router.query.tdClick;
        // Example for tradeDoublerUrl: https://clk.tradedoubler.com/click?p=301944&a=3146932&g=24832700
        if (!url || !url.match(/^https:\/\/clk\.tradedoubler\.com\/click\?p=\d+&a=\d+&g=\d+/)) {
            return null;
        }
        var queryString = "&url=".concat(encodeURIComponent(bookingUrl));
        var redirectUrl = url + queryString;
        return redirectUrl;
    }, [
        router.query
    ]);
    return {
        redirectToTradedoubler: redirectToTradedoubler
    };
};
